module.exports = __webpack_public_path__ + "img/img10.272aee18.png";